import { render, staticRenderFns } from "./extra-search-results.vue?vue&type=template&id=25eeb5dd&scoped=true&lang=pug&"
import script from "./extra-search-results.vue?vue&type=script&lang=js&"
export * from "./extra-search-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eeb5dd",
  null
  
)

export default component.exports